export const onlyNumbers = (s) => {
  return s.replace(/\D/g, '')
}



// WEBPACK FOOTER //
// ./src/helpers/numbers.js